import '../styles/pages/page.scss'

const Story = () => (
    <div className="page-container">
        <article className="main-container">
            <h1 className="main-title">
                Story
            </h1>
            <div className="story-wrapper">
                <p>
                    A young girl awakens in a <span className="blue">strange, dark forest</span> with no memory of how she got there. The last thing she remembers was walking up to the school rooftop at dusk.
                </p>
                <p>
                    Wandering through the forest, the girl meets a <span className="blue">mysterious individual</span>. This person speaks to her in a voice she faintly remembers from somewhere in her past...
                </p>
                <p>
                    "You've been placed under a powerful curse. In order to break it, you need to remember the <span className="blue">important things you've forgotten</span>. You have until dawn."
                </p>
                <p>
                    And so, in search of her lost memories, the young girl ventures out into the eerie streets of her town at night.
                </p>
            </div>
        </article>
    </div>
)
export default Story;